export default __webpack_public_path__ + "static/media/asset_icn.c102111f.png";